// useOnboarding.jsx


import { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import app from '../firebase'; 
import {db as firestore} from "../firebase"

const storage = getStorage(app);

export const useOnboarding = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const uploadFile = async (userId, file) => {
    const storageRef = ref(storage, `users/${userId}/businessDocs/${file.name}`);
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
  };

  const saveOnboardingData = async (userId, data) => {
    const userRef = doc(firestore, 'users', userId);
    try {
      await updateDoc(userRef, {
        onboarding: data,
      });
    } catch (err) {
      throw new Error('Failed to save onboarding data: ' + err.message);
    }
  };

  const submitOnboarding = async (userId, formData, file) => {
    setLoading(true);
    setError('');

    try {
      let fileURL = '';
      if (file) {
        fileURL = await uploadFile(userId, file);
      }

      const onboardingData = {
        ...formData,
        documentURL: fileURL,
        disclosureAccepted: true,
        createdAt: new Date().toISOString(),
      };

      await saveOnboardingData(userId, onboardingData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    submitOnboarding,
  };
};

